import React from 'react';

function DropButton({ children, onClick, disabled }) {
  return (
    <button
      id="controls-dropbutton-button"
      data-testid="controls-dropbutton-button"
      onClick={onClick}
      className="flex flex-xy-center"
      disabled={disabled}
      style={{
        width: '100%',
        height: '50%',
        background:
          'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), #E2E2E2',
        border: '1px solid #BDBDBD',
      }}
    >
      {children}
    </button>
  );
}

export default DropButton;
